import { Grid } from "@material-ui/core";

import ReportRunActions from "./report-run-actions";
import { useAppSelector } from "../../hooks/useAppSelector";
import { useReportRun } from "../../hooks/useReportRun";
import { getCurrentUser } from "../../store/userStore";
import { EmailedReportPanelProps } from "../../interface/forms/EmailedReportPanelProps";
import {
  emailedReportResult,
  failedReportResult,
} from "../../utils/report-run";

const EmailedReportPanel = ({
  title,
  emptyMessage,
  runningMessage,
  facts,
  canSend = true,
  sendLabel = "Send Report",
  sendingLabel = "Sending Report...",
  send,
  onRunStateChange,
  children,
}: EmailedReportPanelProps) => {
  const user = useAppSelector(getCurrentUser);
  const run = useReportRun(onRunStateChange);

  const onSend = async () => {
    if (!canSend) return;

    run.start(runningMessage ?? `Building the ${title}...`);

    try {
      const response = await send(
        user?.username ? [user.username] : undefined,
      );

      run.publish(
        emailedReportResult(response, {
          recipient: user?.username,
          emptyMessage,
          facts,
        }),
      );
    } catch (error) {
      run.publish(failedReportResult(error));
    }
  };

  return (
    <Grid container spacing={3}>
      {children}

      <Grid item xs={12}>
        <ReportRunActions
          title={title}
          run={run}
          onRun={onSend}
          label={sendLabel}
          runningLabel={sendingLabel}
          disabled={!canSend}
        />
      </Grid>
    </Grid>
  );
};

export default EmailedReportPanel;
